import i18n from 'i18next';
// import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from 'react-i18next';
import en from './en';
import vi from './vi';
import korea from './korea';
import consts from '../consts';

i18n
// .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en,
      korea,
      vi,
    },
    fallbackLng: window.localStorage.getItem('LANG') || consts.VI,
    // debug: true,

    // have a common namespace used around the full app
    ns: ['default'],
    defaultNS: 'default',

    keySeparator: false, // we use content as keys

    interpolation: {
      escapeValue: false,
    },
  });
